import { UserPlus, Settings, TrendingUp } from 'lucide-react';

const steps = [
  {
    icon: Settings,
    title: 'Create budgets & policies',
    description: 'Set up spending categories, limits, and approval rules. Define policies that match your business needs.'
  },
  {
    icon: UserPlus,
    title: 'Invite teammates + issue cards',
    description: 'Add team members with custom roles and permissions. Issue cards with individual spending controls.'
  },
  {
    icon: TrendingUp,
    title: 'Track, collect receipts, export',
    description: 'Monitor all activity in real-time. Capture receipts automatically and export clean records for accounting.'
  }
];

const HowItWorks = () => {
  return (
    <section id="how-it-works" className="py-24 md:py-32 relative bg-white/[0.02]">
      <div className="container mx-auto">
        <div className="text-center mb-16 space-y-4">
          <h2 className="text-4xl md:text-5xl font-bold heading-font text-white">
            Get started in minutes
          </h2>
          <p className="text-lg text-gray-400 max-w-2xl mx-auto">
            Simple setup. Powerful controls. Complete visibility.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 max-w-5xl mx-auto">
          {steps.map((step, index) => {
            const Icon = step.icon;
            return (
              <div key={index} className="relative">
                {/* Connector line */}
                {index < steps.length - 1 && (
                  <div className="hidden md:block absolute top-12 left-[60%] w-[80%] h-[2px] bg-gradient-to-r from-indigo-600/50 to-transparent"></div>
                )}
                
                <div className="relative z-10 text-center space-y-4">
                  <div className="w-24 h-24 mx-auto bg-gradient-to-br from-indigo-600/20 to-cyan-600/20 rounded-2xl flex items-center justify-center border border-white/10 backdrop-blur-sm">
                    <Icon size={32} className="text-indigo-400" />
                  </div>
                  <div className="space-y-2">
                    <div className="text-sm font-semibold text-indigo-400">Step {index + 1}</div>
                    <h3 className="text-2xl font-semibold text-white heading-font">
                      {step.title}
                    </h3>
                    <p className="text-gray-400 leading-relaxed">
                      {step.description}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
